import {
  AppBar,
  Toolbar,
  IconButton,
  Box,
  Avatar,
  Typography,
} from "@mui/material";
import LogoutIcon from "@mui/icons-material/Logout";
import { useNavigate } from "react-router-dom";
import { supabase } from "../supabase";

export default function Header({ user }) {
  const navigate = useNavigate();

  const handleLogout = async () => {
    await supabase.auth.signOut();
    navigate("/");
  };

  return (
    <AppBar
      position="fixed"
      elevation={0}
      sx={{
        backgroundColor: "#f5f5f5",
        color: "#000",
        zIndex: 1201,
      }}
    >
      <Toolbar sx={{ display: "flex", justifyContent: "space-between", minHeight: 64 }}>
        <Box sx={{ display: "flex", alignItems: "center" }}>
          <img
            src="/logo/Maniko_logo.webp"
            alt="Logo"
            onClick={() => navigate("/dashboard")}
            style={{ height: 28, cursor: "pointer" }}
          />
        </Box>

        <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
          <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
            <Avatar
              sx={{
                width: 32,
                height: 32,
                bgcolor: "#ddd",
                color: "#888",
                fontSize: "0.875rem",
                textTransform: "uppercase",
              }}
            >
              {name?.charAt(0) || "?"}
            </Avatar>
            <Box>
              <Typography variant="body2" sx={{ fontWeight: 500 }}>{user?.name}</Typography>
              <Typography variant="caption" sx={{ color: "#888" }}>{user?.role} account</Typography>
            </Box>
          </Box>

          <IconButton edge="end" color="inherit" onClick={handleLogout}>
            <LogoutIcon />
          </IconButton>
        </Box>
      </Toolbar>

      {/* Styled divider line */}
      <Box
        component="hr"
        sx={{
          border: 0,
          height: '1px',
          backgroundColor: '#d0d0d0',
          width: '100%',
          margin: 0,
        }}
      />
    </AppBar>
  );
}
